import { Box } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import SpacingContainerBase from '../../../components/layouts/SpacingContainerBase';
import { SCOPE_SAVED_SEARCHES } from '../../../constants/search';
import connect from '../connect';
import SavedSearchesList from './List';

function SavedSearches({ userDetail, onInitSavedSearches }) {
  React.useEffect(() => {
    if (onInitSavedSearches && userDetail?.userName) {
      onInitSavedSearches(userDetail.userName)
    }
  }, [onInitSavedSearches, userDetail?.userName]);

  return (
    <SpacingContainerBase>
      <SavedSearchesList scope={SCOPE_SAVED_SEARCHES} />
      <Box my={4} />
    </SpacingContainerBase>
  );
}

SavedSearches.propTypes = {
  userDetail: PropTypes.shape({
    userName: PropTypes.string,
  }),
  onInitSavedSearches: PropTypes.func,
};

export default connect(SavedSearches);
